import { createTheme } from '@mui/material';

const colors = {
  primary: '#1C78A3',
  secondary: '#40C2EE',
  accent1: '#329C66',
  accent2: '#41B789',
  background: {
    light: '#FFFFFF',
    dark: '#121212'
  },
  text: {
    light: '#333333',
    dark: '#FFFFFF'
  }
};

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
    },
    background: {
      default: colors.background.light,
      paper: '#F5F5F5',
    },
    text: {
      primary: colors.text.light,
    },
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: colors.primary,
    },
    secondary: {
      main: colors.secondary,
    },
    background: {
      default: colors.background.dark,
      paper: '#1E1E1E',
    },
    text: {
      primary: colors.text.dark,
    },
  },
  typography: {
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif',
  },
});
